import { render, staticRenderFns } from "./AppFormError.vue?vue&type=template&id=4aa559d4&"
import script from "./AppFormError.vue?vue&type=script&lang=ts&"
export * from "./AppFormError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports